import { useState, useEffect, useCallback } from "react";
import { getPagePaymentPackage } from "shared/api/services";
import { IExportedPackage } from "../types";
import { mapPaymentPackageToExportedPackage } from "../helper/mapperExportedPackages";

export const usePaymentPackage = (consecutive?: string) => {
  const [packageData, setPackageData] = useState<IExportedPackage | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPackageData = useCallback(async () => {
    if (!consecutive) {
      setPackageData(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await getPagePaymentPackage({ consecutive });
      if (response.content && response.content.length > 0) {
        const mappedData = mapPaymentPackageToExportedPackage(
          response.content[0],
        );
        setPackageData(mappedData);
      } else {
        setPackageData(null);
      }
    } catch (err) {
      setError("Error al cargar los datos del paquete");
      console.error("Error fetching payment package:", err);
    } finally {
      setIsLoading(false);
    }
  }, [consecutive]);

  useEffect(() => {
    fetchPackageData();
  }, [fetchPackageData]);

  return { packageData, isLoading, error, refetch: fetchPackageData };
};
